import React from 'react';
import { BOX_IMAGE, CHECKOUT_URL, PURCHASE_ANCHOR } from '../data/content';
interface BoxImageProps {
  className?: string;
  target?: 'purchase' | 'checkout';
}
export function BoxImage({
  className = '',
  target = 'purchase'
}: BoxImageProps) {
  return <a href={target === 'checkout' ? CHECKOUT_URL : PURCHASE_ANCHOR} className={`block ${className}`} data-id="element-27" data-mp="2rvi4319vzhg6">
      <img src={BOX_IMAGE} alt="CARDIOLOGY VISUAL ATLAS™ complete 6-in-1 visual study system box set" className="mx-auto w-full drop-shadow-2xl" data-id="element-28" data-mp="2mwoqz9yihsgj" />
    </a>;
}